export const MAX_AUDIO_FILE_SIZE_BYTES = 2 * 1024 * 1024 * 1024; // 2GB
export const MAX_AUDIO_FILE_SIZE_MB = 2048; // 2GB in MB
export const SUPPORT_URL = 'https://thedmsark.com/support';
